import { render, staticRenderFns } from "./ContentsHeader.vue?vue&type=template&id=5e1dffca&scoped=true"
import script from "./ContentsHeader.vue?vue&type=script&lang=js"
export * from "./ContentsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1dffca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1dffca')) {
      api.createRecord('5e1dffca', component.options)
    } else {
      api.reload('5e1dffca', component.options)
    }
    module.hot.accept("./ContentsHeader.vue?vue&type=template&id=5e1dffca&scoped=true", function () {
      api.rerender('5e1dffca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ContentsHeader.vue"
export default component.exports